import { render, staticRenderFns } from "./check-admin.vue?vue&type=template&id=3b8dfdce"
import script from "./check-admin.vue?vue&type=script&lang=js"
export * from "./check-admin.vue?vue&type=script&lang=js"
import style0 from "./check-admin.vue?vue&type=style&index=0&id=3b8dfdce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports